module.exports = __webpack_public_path__ + "img/orange_052.1f7aa8f8.png";